document.addEventListener('DOMContentLoaded', function () {
  'use strict';

  function installCroStyles() {
    if (document.getElementById('rof-cro-fixes')) return;

    var style = document.createElement('style');
    style.id = 'rof-cro-fixes';
    style.textContent = [
      '/* Persistent header and navigation */',
      '#header.header, .nav { position: relative !important; top: auto !important; }',
      'body.rof-header-fixed #header.header {',
      '  position: fixed !important; top: 0 !important; left: 0 !important; right: 0 !important;',
      '  width: 100% !important; z-index: 100000 !important; background: #fff;',
      '  box-shadow: 0 8px 28px rgba(15,35,24,.14);',
      '}',
      'body.rof-header-fixed .nav {',
      '  position: fixed !important; top: var(--rof-fixed-header-height, 87px) !important;',
      '  left: 0 !important; right: 0 !important; width: 100% !important;',
      '  z-index: 99999 !important;',
      '}',
      '.rof-header-spacer { display: none; }',
      'body.rof-header-fixed .rof-header-spacer { display: block; height: var(--rof-fixed-stack-height, 135px); }',
      '',
      '/* Larger premium product cards */',
      '.products .container .rof-home-grid,',
      '.rof-collection-filter-page .rof-filter-layout .rof-products-area .rof-cards-grid {',
      '  grid-template-columns: repeat(3, minmax(0, 1fr)) !important;',
      '  gap: 24px !important;',
      '}',
      '.rof-card {',
      '  border-radius: 20px !important;',
      '  overflow: hidden !important;',
      '  border: 1px solid #e3e8e4 !important;',
      '  box-shadow: 0 12px 34px rgba(15,35,24,.08) !important;',
      '  background: #fff !important;',
      '  transition: transform .22s ease, box-shadow .22s ease !important;',
      '}',
      '.rof-card:hover { transform: translateY(-4px) !important; box-shadow: 0 20px 48px rgba(15,35,24,.14) !important; }',
      '.rof-card__media, .rof-card__media > a, .rof-card__img-wrap {',
      '  width: 100% !important; margin: 0 !important; padding: 0 !important;',
      '}',
      '.rof-card__media { overflow: hidden !important; background: #f6f7f5 !important; }',
      '.rof-card__media > a { display: block !important; height: 100% !important; }',
      '.rof-card__img-wrap {',
      '  height: auto !important; min-height: 0 !important; aspect-ratio: 4 / 5 !important;',
      '  overflow: hidden !important; background: #f6f7f5 !important;',
      '}',
      '.rof-card__img {',
      '  display: block !important; width: 100% !important; height: 100% !important;',
      '  object-fit: contain !important; object-position: center !important;',
      '  margin: 0 !important; padding: 0 !important; transform: none !important;',
      '}',
      '.rof-card:hover .rof-card__img, .rof-card__media:hover .rof-card__img { transform: none !important; }',
      '.rof-card__body { padding: 20px !important; }',
      '.rof-card__title { font-size: 1.04rem !important; line-height: 1.35 !important; }',
      '.rof-card__price, .rof-card__price-current { font-size: 1.28rem !important; font-weight: 900 !important; }',
      '.rof-card__trust {',
      '  display: grid; grid-template-columns: 1fr 1fr; gap: 7px 10px;',
      '  margin: 14px 0 16px; padding: 12px; border-radius: 12px;',
      '  background: #f1f8f4; border: 1px solid #d8ebdf;',
      '}',
      '.rof-card__trust span {',
      '  display: flex; align-items: flex-start; gap: 6px;',
      '  color: #184d2f; font-size: 11.5px; line-height: 1.35; font-weight: 750;',
      '}',
      '.rof-card__trust b { color: #087a3d; font-weight: 950; flex: 0 0 auto; }',
      '@media screen and (max-width: 1100px) {',
      '  .rof-collection-filter-page .rof-filter-layout .rof-products-area .rof-cards-grid { grid-template-columns: repeat(2, minmax(0,1fr)) !important; gap: 18px !important; }',
      '  .products .container .rof-home-grid { grid-template-columns: repeat(3, minmax(0,1fr)) !important; gap: 18px !important; }',
      '}',
      '@media screen and (max-width: 900px) {',
      '  .products .container .rof-home-grid,',
      '  .rof-collection-filter-page .rof-filter-layout .rof-products-area .rof-cards-grid { grid-template-columns: repeat(2, minmax(0,1fr)) !important; gap: 14px !important; }',
      '}',
      '@media screen and (max-width: 700px) {',
      '  .rof-card__body { padding: 14px !important; }',
      '  .rof-card__trust { grid-template-columns: 1fr; gap: 5px; padding: 10px; }',
      '  .rof-card__trust span { font-size: 10.5px; }',
      '}',
      '@media screen and (max-width: 420px) {',
      '  .products .container .rof-home-grid,',
      '  .rof-collection-filter-page .rof-filter-layout .rof-products-area .rof-cards-grid { gap: 10px !important; }',
      '  .rof-card { border-radius: 14px !important; }',
      '  .rof-card__body { padding: 11px !important; }',
      '  .rof-card__title { font-size: .9rem !important; }',
      '  .rof-card__trust { margin: 10px 0 12px; }',
      '}'
    ].join('\n');
    document.head.appendChild(style);
  }

  function setupPersistentHeader() {
    var header = document.getElementById('header');
    var nav = document.querySelector('.nav');
    if (!header || !nav) return;

    var spacer = document.querySelector('.rof-header-spacer');
    if (!spacer) {
      spacer = document.createElement('div');
      spacer.className = 'rof-header-spacer';
      spacer.setAttribute('aria-hidden', 'true');
      header.parentNode.insertBefore(spacer, header);
    }

    var triggerTop = 0;
    var ticking = false;

    function setDimensions() {
      var headerHeight = Math.ceil(header.getBoundingClientRect().height);
      var navHeight = Math.ceil(nav.getBoundingClientRect().height);
      document.documentElement.style.setProperty('--rof-fixed-header-height', headerHeight + 'px');
      document.documentElement.style.setProperty('--rof-fixed-stack-height', (headerHeight + navHeight) + 'px');
    }

    function measure() {
      document.body.classList.remove('rof-header-fixed');
      triggerTop = Math.max(0, Math.round(header.getBoundingClientRect().top + window.pageYOffset));
      setDimensions();
      update();
    }

    function update() {
      var shouldFix = window.pageYOffset >= triggerTop;
      document.body.classList.toggle('rof-header-fixed', shouldFix);
      if (shouldFix) setDimensions();
      ticking = false;
    }

    function requestUpdate() {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(update);
    }

    window.addEventListener('scroll', requestUpdate, { passive: true });
    window.addEventListener('resize', function () {
      window.clearTimeout(setupPersistentHeader.resizeTimer);
      setupPersistentHeader.resizeTimer = window.setTimeout(measure, 120);
    });

    window.addEventListener('load', measure, { once: true });
    measure();
  }

  function enhanceProductCard(card) {
    if (!card || card.nodeType !== 1 || card.getAttribute('data-rof-trust-enhanced') === 'true') return;
    card.setAttribute('data-rof-trust-enhanced', 'true');

    var stock = card.querySelector('.rof-card__stock');
    if (stock) stock.remove();

    var actions = card.querySelector('.rof-card__actions');
    var body = card.querySelector('.rof-card__body');
    if (!body || !actions) return;

    var trust = document.createElement('div');
    trust.className = 'rof-card__trust';
    trust.setAttribute('aria-label', 'Product assurances');
    trust.innerHTML = [
      '<span><b aria-hidden="true">✓</b> Professionally refurbished</span>',
      '<span><b aria-hidden="true">✓</b> Quality checked</span>',
      '<span><b aria-hidden="true">↩</b> 14-day returns</span>',
      '<span><b aria-hidden="true">🚚</b> UK delivery available</span>'
    ].join('');

    actions.parentNode.insertBefore(trust, actions);
  }

  function enhanceAllProductCards(root) {
    if (!root || !root.querySelectorAll) return;
    if (root.matches && root.matches('.rof-card')) enhanceProductCard(root);
    root.querySelectorAll('.rof-card').forEach(enhanceProductCard);
  }

  function observeProductCards() {
    enhanceAllProductCards(document);
    if (!('MutationObserver' in window) || !document.body) return;

    var observer = new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        mutation.addedNodes.forEach(function (node) {
          if (node.nodeType === 1) enhanceAllProductCards(node);
        });
      });
    });
    observer.observe(document.body, { childList: true, subtree: true });
  }

  installCroStyles();
  setupPersistentHeader();
  observeProductCards();

  var menuBtn = document.querySelector('.mobile-menu-toggle');
  var navInner = document.querySelector('.nav .nav-inner');
  if (menuBtn && navInner) {
    menuBtn.addEventListener('click', function () {
      navInner.classList.toggle('mobile-open');
      document.body.classList.toggle('menu-open');
    });
  }

  document.querySelectorAll('.nav-item.has-dropdown > a').forEach(function (link) {
    link.addEventListener('click', function (event) {
      if (window.innerWidth <= 768) {
        event.preventDefault();
        link.parentElement.classList.toggle('mobile-open');
      }
    });
  });

  document.addEventListener('click', function (event) {
    if (!event.target.closest('.site-search')) {
      document.querySelectorAll('.search-results').forEach(function (element) {
        element.classList.remove('active');
      });
    }
  });

  var revealElements = document.querySelectorAll('.fade-up');
  if ('IntersectionObserver' in window) {
    var revealObserver = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('visible');
          revealObserver.unobserve(entry.target);
        }
      });
    }, { threshold: 0.1 });
    revealElements.forEach(function (element) { revealObserver.observe(element); });
  } else {
    revealElements.forEach(function (element) { element.classList.add('visible'); });
  }

  document.querySelectorAll('.filter-tab').forEach(function (tab) {
    tab.addEventListener('click', function () {
      document.querySelectorAll('.filter-tab').forEach(function (item) { item.classList.remove('active'); });
      tab.classList.add('active');
    });
  });

  document.querySelectorAll('.mobile-menu-close, .mobile-menu-overlay').forEach(function (element) {
    element.addEventListener('click', function () {
      document.body.classList.remove('menu-open');
      var currentNav = document.querySelector('.nav .nav-inner');
      if (currentNav) currentNav.classList.remove('mobile-open');
    });
  });
});
